module.exports = __webpack_public_path__ + "static/media/nautilus_logo.94e8f223.png";